import { render, staticRenderFns } from "./CommunityHealthinfoCard.vue?vue&type=template&id=6521a335&scoped=true&"
import script from "./CommunityHealthinfoCard.vue?vue&type=script&lang=js&"
export * from "./CommunityHealthinfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6521a335",
  null
  
)

export default component.exports